import { removeAutopilotEmoji } from "../../../util/event.util";
import getFlexibilityIsEditable from "../../../util/getFlexibilityIsEditable";
import getStartDateTime from "../../../util/getStartDateTime";
import isTimeRangeFlexible from "../../../util/isTimeRangeFlexible";
import { OneOffHoldsQuery } from "../graphql/__generated__/OneOffHolds.generated";

export const parseOneOffHoldsGQL = (data: OneOffHoldsQuery | undefined) => {
  const dataObj =
    data?.viewer?.user?.orgs?.edges?.[0]?.node?.flexibleMeetingsDashboard?.myOneOffHolds;

  return (
    dataObj?.map((datum) => ({
      flexible: isTimeRangeFlexible(datum),
      flexibilityEditable: getFlexibilityIsEditable(datum),
      id: datum.id,
      startTime: getStartDateTime(datum),
      title: removeAutopilotEmoji(datum.title) || "Untitled Event",
    })) || []
  );
};

export default parseOneOffHoldsGQL;
